// @ts-nocheck
import { z } from "zod";
export const offeringContextSchema = z.object({ "id": z.string(), "name": z.string(), "description": z.union([z.string(), z.null()]).default(null), "context": z.union([z.record(z.any()), z.null()]).default(null) }).describe("Offering/product information");
